import { GTMEvents, sendGTMEvent, initializeGTM } from './gtm.ts';

// Configuration Google Tag Manager
export const initGA = (measurementId?: string) => {
  // GTM est déjà initialisé dans index.html, on fait juste l'initialisation React
  initializeGTM();
};

// Tracker les pages vues
export const trackPageView = (path: string, title?: string) => {
  GTMEvents.pageView(title || path);
};

// Tracker les événements personnalisés
export const trackEvent = (eventName: string, parameters?: Record<string, any>) => {
  sendGTMEvent({
    event: eventName,
    ...parameters
  });
};

// Événements spécifiques pour QuizVS
export const trackGameEvents = {
  gameStarted: (gameMode: 'local' | 'multiplayer', playerCount: number) => {
    GTMEvents.gameStart(gameMode, playerCount, 'normal'); // difficulté par défaut
  },
  
  gameCompleted: (gameMode: 'local' | 'multiplayer', duration: number, winner: string) => {
    GTMEvents.gameEnd(gameMode, duration, winner);
  },
  
  questionAnswered: (category: string, difficulty: number, isCorrect: boolean) => {
    GTMEvents.questionAnswered(category, isCorrect, difficulty);
  },
  
  lobbyJoined: (lobbyCode: string, playerCount: number) => {
    GTMEvents.roomJoined(lobbyCode);
  },
  
  userRegistered: (method: 'google' | 'email' | 'anonymous') => {
    sendGTMEvent({
      event: 'sign_up',
      method: method,
      category: 'User'
    });
  },
  
  userLoggedIn: (method: 'google' | 'email' | 'anonymous') => {
    sendGTMEvent({
      event: 'login',
      method: method,
      category: 'User'
    });
  }
};

// Consentement des cookies
export const setAnalyticsConsent = (granted: boolean) => {
  // Fonction gtag globale pour le consentement
  const gtag = (window as any).gtag || function() {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push(arguments);
  };
  
  if (granted) {
    // Mettre à jour le consentement GTM via gtag (plus fiable)
    gtag('consent', 'update', {
      'analytics_storage': 'granted',
      'ad_storage': 'granted'
    });
    
    // Envoyer aussi l'événement personnalisé
    GTMEvents.consentGiven('analytics');
    localStorage.setItem('analytics_consent', 'granted');
    
    console.log('✅ [Analytics] Consentement accordé - GTM activé');
  } else {
    // Refuser le consentement GTM via gtag
    gtag('consent', 'update', {
      'analytics_storage': 'denied',
      'ad_storage': 'denied'
    });
    
    GTMEvents.consentDenied('analytics');
    localStorage.setItem('analytics_consent', 'denied');
    
    console.log('❌ [Analytics] Consentement refusé - GTM désactivé');
  }
};

// Vérifier le consentement existant
export const checkAnalyticsConsent = (): boolean | null => {
  const consent = localStorage.getItem('analytics_consent');
  if (consent === 'granted') return true;
  if (consent === 'denied') return false;
  return null; // Pas encore défini
};
